import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import {Row, Col, Spinner, CardTitle, Form, Label, Table, Modal, ModalBody, Button, ModalHeader,} from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import Select from "react-select";
import API from "../../apis";
import {Link} from "react-router-dom";
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import apis from "../../apis";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

const DataTableAffectationSujet = props => {
  const lng = localStorage.getItem("I18N_LANGUAGE")
  var userAuthEnseignant = JSON.parse(
      localStorage.getItem("userAuthEnseignant")
  )
  var enseignant_id = userAuthEnseignant.user.enseignant_id
  var annee_id = userAuthEnseignant.user.annee_id
  var departement_id = userAuthEnseignant.user.departement_id
  //
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [mode, setMode] = useState("nouveau");
  const [nouveauSujet, setNouveauSujet] = useState("");

  const [sujet, setSujet] = useState([])
  const [selectSujet, setSelectSujet] = useState("")
  // Data Table
  const [avisAbsence, setAvisAbsence] = useState([])

  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: avisAbsence.length,
    page: 1,
    nextPageText: props.t("Suivant"),
    prePageText: props.t("Précedent"),
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: avisAbsence.length,
      },
    ],
  }

  const NoDataIndication = () => (
      <h6 style={{ textAlign: "center" }}>Aucun information à afficher</h6>
  )
  const Columns = () => [
    {
      dataField: "annee_scolaire",
      text: props.t("Année scolaire"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "enseignant_name",
      text: props.t("Enseignant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "etudiant_name",
      text: props.t("Etudiant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "group_name",
      text: props.t("Groupe"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "cycle_name",
      text: props.t("Cycle"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite_name",
      text: props.t("Spécialite"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "sujet_name",
      text: props.t("Nom de sujet"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "Sujet",
      isDummyField: true,
      text: props.t("Sujet"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
                style={{ color: "rgba(6,94,57,0.44)", cursor: "pointer" }}
                onClick={() => toggle(row.id)}
                className="fas fa-graduation-cap"
            ></i>
          </div>
      ),
    },

  ]

  const { SearchBar } = Search

  useEffect(async () => {
    const res = await apis
        .post("etudiant/etudiant_effectue_enseignant", { annee_id: annee_id ,departement_id,enseignant_id})
        .then(res => {
          setAvisAbsence(res.data.data)
        })

    setLoading(true)
  }, [])

  const toggle = id => {
    setModal(!modal)
    setId(id)
    setSelectSujet("")
    setNouveauSujet("")
    setMode("nouveau")
    const resSujet =  apis
        .post("etudiant/list_sujet", { annee_id: annee_id ,enseignant_id})
        .then(resSujet => {
          setSujet(resSujet.data.data)
        })
  }

  const getSujet = () => {
    setMode("nouveau");
    setSelectSujet("");
  };
  const toggleDelete = async () => {
    setModal(!modal)
    const res = await apis
        .post("etudiant/add_subject", {
          etudiant_ens_pfe_id: id,
          annee_id,
          enseignant_id,
          sujet_id:selectSujet.value,
          sujet_name:nouveauSujet
        }).then(res => {
          const resList =  apis
              .post("etudiant/etudiant_effectue_enseignant", { annee_id: annee_id ,departement_id,enseignant_id})
              .then(resList => {
                setAvisAbsence(resList.data.data)
              })
          setLoading(true)
        })
  }

  const toggleAnnuler = async () => {
    setModal(!modal)
    const res = await apis
        .post("etudiant/delete_sujet", {
          etudiant_ens_pfe_id: id,
        }).then(res => {
          const resList =  apis
              .post("etudiant/etudiant_effectue_enseignant", { annee_id: annee_id,departement_id ,enseignant_id})
              .then(resList => {
                setAvisAbsence(resList.data.data)
              })
          setLoading(true)
        })
  }

  useEffect(() => {
    setModal(false)
  }, [avisAbsence])

  return (
      <React.Fragment>
        <div>
          {loading ? (
              <Row>
                <Col xs="12">
                  <ToolkitProvider
                      keyField="id"
                      data={avisAbsence}
                      columns={Columns()}
                      search
                      bootstrap4
                  >
                    {toolkitProps => (
                        <div>
                          <Col sm="4">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <BootstrapTable
                              wrapperClasses="table-responsive"
                              noDataIndication={() => <NoDataIndication />}
                              striped={false}
                              bordered={false}
                              classes={"table align-middle table-nowrap"}
                              headerWrapperClasses={"table-light"}
                              hover
                              pagination={paginationFactory(pageOptions)}
                              {...toolkitProps.baseProps}
                          />
                        </div>
                    )}
                  </ToolkitProvider>
                </Col>
              </Row>
          ) : (
              <div>
                <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                >
                  {" "}
                  <Spinner type="grow" className="ms-6" color="primary" />
                </div>
                <h4
                    style={{ textAlign: "center", marginTop: "2%" }}
                    className="ms-6"
                >
                  {" "}
                  {props.t("Chargement en cours...")}
                </h4>
              </div>
          )}
        </div>
        {/* <> */}
        <Modal isOpen={modal} toggle={toggle} centered={true}>
          <div
              className="modal-header"
              style={{
                width: "100% !important",
                justifyContent: "center !important",
                margin: "0 auto",
                fontSize: "17px",
              }}
              toggle={toggle}
          >
            {props.t("Affecter un sujet aux étudiants")}
          </div>
          <ModalBody>
            <div
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  FontSize: "14px",
                  FontWeight: "700",
                  LineHeight: "18.375px",
                }}
            >
              <div>
                <Row>
                  <Col lg="6">
                    <div className="mb-3">
                      <input
                          type="radio"
                          name="mode"
                          value={mode}
                          checked={mode === "nouveau"}
                          onChange={() => getSujet()}
                      />
                      <Label for="basicpill-firstname-input1">&nbsp;&nbsp;&nbsp;Créer un nouveau sujet</Label>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3">
                      <input
                          type="radio"
                          name="mode"
                          value="existant"
                          checked={mode === "existant"}
                          onChange={() => setMode("existant")}
                      />
                      <Label for="basicpill-firstname-input1"> &nbsp;&nbsp;&nbsp;Réaffecter un sujet existant</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6">
                    {mode === "nouveau" && (
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">Entrer un nouveau sujet :</Label>
                          <input
                              type="text"
                              className="form-control"
                              value={nouveauSujet}
                              onChange={(e) => setNouveauSujet(e.target.value)}
                              placeholder="Titre du nouveau sujet"
                          />
                        </div>
                    )}
                    {mode === "existant" && (
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">Sujets disponibles :</Label>
                          <Select
                              options={sujet}
                              value={selectSujet}
                              onChange={e => setSelectSujet(e)}
                              placeholder="Sélectionner un sujet..."
                          />
                        </div>
                    )}
                    </Col>

                </Row>
              </div>
              <div
                  className="hvr-push"
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    marginBottom: "15px",
                  }}
              >
                <div>
                  <Button
                      color="info"
                      className="btn-rounded "
                      onClick={toggleDelete}
                  >
                    <i
                        style={{color: "white"}}
                        className="far fa-thumbs-up"
                    ></i>
                    {props.t("Affecter sujet")}
                  </Button>
                </div>
                <div>
                  <Button
                      onClick={toggleAnnuler}
                      color="danger"
                      className="btn-rounded "
                  >
                    <i
                        style={{color: "white"}}
                        className="far fa-thumbs-down"
                    ></i>
                    {props.t("Annuler l'affectation de sujet")}
                  </Button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

      </React.Fragment>
  )
}


export default withRouter(withTranslation()(DataTableAffectationSujet))
DataTableAffectationSujet.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
